import React from 'react';
import { Hero1 } from '../components/Data/Arabic';
import { Hero2 } from '../components/Data/English';
// import './Main.css';


const Hero = ({lang}) => {

  const Data = lang ? Hero2 : Hero1;

  return (
    <div className="flex items-center sm:w-full justify-between lg:px-32 px-32 sm:mt-0 sm:py-0 lg:mt-0 md:px-14 sm:px-12 h-[75vh] xl:max-w-[1400px] xl:mx-auto">
       <div className='w-2/4'>
           <img src="assets/images/person.svg" alt=""   
             className='pr-10 sm:pr-0 pt-8 w-fit mr-8 xl:mr-5 lg:mr-0 lg:w-3/4 md:w-3/4 md:mr-4 sm:-mr-5 md:pr-0 sm:w-11/12 sm:mb-5'
           />        
        </div>
        <div className={lang ? "w-2/4 flex p-0 -mt-9  md:mt-9 lg:mb-9 xl:mb-9" 
        : "w-2/4 flex p-0 -mt-9 -ml-[8%]  md:mt-9 lg:mb-9 xl:mb-9"}>
            {
              Data.map( item => (
                <p key={item.id} className=" w-full flex-col justify-around xl:text-[2.5rem] lg:text-3xl xl:leading-loose lg:leading-[2] md:text-2xl sm:text-[12px] sm:leading-8 font-black relative leading-loose md:leading-loose transition-transform duration-700">
                  <span className={lang ? 'absolute sm:-left-[10%] md:left-[14%] lg:left-[6%] xl:left-[6%]'
                  : 'absolute sm:-right-[13%] md:-right-[12%] lg:-right-[14%] xl:-right-[10%]'} >
                    {item.line1}
                  </span> <br/>
                  <span className={lang ? 'absolute sm:-left-[3%] md:left-[17%] md:right-auto lg:left-[8%] xl:left-[14%]' 
                   : 'absolute sm:-right-[8%] md:-right-[5%] lg:-right-[10%] xl:-right-[5%]' } >
                    {item.line2}
                  </span> <br/>
                  <span className={lang ? 'absolute sm:left-[3%] md:left-[21%] lg:left-[12%] xl:left-[20%]' 
                    : 'absolute sm:-right-[6%] md:right-[3%] lg:-right-[1%] xl:-right-[1%]'} >
                    {item.line3}
                  </span>
                </p>
              ))
            }
        </div>
    </div>
  )
}

export default Hero;
